import { forwardRef } from "react";
import Map, { type MapProps, type MapRef as ReactMapRef } from "@vis.gl/react-maplibre";
import "maplibre-gl/dist/maplibre-gl.css";
import { AIRTIME_MAP_STYLE } from "./airtime_map_style";

export { FullscreenControl, Layer, NavigationControl, Source } from "@vis.gl/react-maplibre";
export type { MapLayerMouseEvent, MapRef } from "@vis.gl/react-maplibre";

type AirtimeMapProps = Omit<MapProps, "mapStyle">;

export const AirtimeMap = forwardRef<ReactMapRef, AirtimeMapProps>(function AirtimeMap(props, ref) {
  return <Map ref={ref} {...props} mapStyle={AIRTIME_MAP_STYLE} />;
});
